import React, { FC, useEffect, useMemo } from 'react'
import { Form, Typography, Col, Row } from 'antd'
import { connect, useSelector } from 'react-redux'
import { debounce } from 'lodash-es'
import SchemaForm, { Schema } from '@/components/schemaForm'
import { setCommonConfig } from '@/store/actions/index'
import legoApi from '@/services/lego'
const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
}

interface CombinationListProps {
  editConfig: (id, name, value) => void
  id: string
  pid: string
  config: {
    ids?: string[]
    condition?: {
      categories?: string[]
      merchants?: string[]
      maxAmount?: number
    }
    combinations?: any[]
  }
}

const CombinationList: FC<CombinationListProps> = ({ editConfig, id, config }) => {
  const {} = config
  const [form] = Form.useForm()
  const { ids, condition, combinations } = config || {}
  const { categoryOptions, merchantOptions } = useSelector<any>(store => ({
    categoryOptions: store.baseData.categories.filter(item => item.id.length === 1),
    merchantOptions: store.baseData.merchants,
  })) as any
  const schema = useMemo(() => {
    const data: Schema = [
      {
        type: 'FormItem',
        props: {
          name: 'ids',
          label: '组合ID',
          normalize: value => (value?.join ? value?.join(',') : value),
        },
        children: {
          type: 'Textarea',
          props: {
            placeholder: '组合ID',
            allowClear: true,
            autoSize: true,
          },
        },
      },
      {
        type: 'FormItem',
        props: {
          name: ['condition', 'categories'],
          label: '类目导入',
        },
        children: {
          type: 'Select',
          props: {
            placeholder: '类目导入',
            mode: 'multiple',
            showSearch: true,
            optionFilterProp: 'children',
          },
          children: categoryOptions.map(item => ({
            type: 'Option',
            props: {
              value: item.value,
              text: item.label,
            },
          })),
        },
      },
      {
        type: 'FormItem',
        props: {
          name: ['condition', 'merchants'],
          label: '商家导入',
        },
        children: {
          type: 'Select',
          props: {
            placeholder: '商家导入',
            mode: 'multiple',
            showSearch: true,
            optionFilterProp: 'children',
          },
          children: merchantOptions.map(item => ({
            type: 'Option',
            props: {
              value: item.value,
              text: item.label,
            },
          })),
        },
      },
      {
        type: 'FormItem',
        props: {
          name: ['condition', 'maxAmount'],
          label: '导入数量',
        },
        children: {
          type: 'Slider',
          props: {
            min: 1,
            max: 100,
            step: 1,
          },
        },
      },
    ]
    return data
  }, [categoryOptions, merchantOptions])
  useEffect(() => {
    form.setFieldsValue({ ids, condition, combinations })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form])
  const setValue = (field, value) => {
    editConfig(id, field, value)
  }
  const getCombinationIds = () => {
    const condition = form.getFieldValue('condition') || {}
    const { categories = [], maxAmount = 0, merchants = [] } = condition
    const queryString = `size=${maxAmount || 20}${
      categories.length ? '&categoryId=' + categories.join(',') : ''
    }${merchants.length ? merchants.map(item => '&merchantId=' + item).join('') : ''}`
    return legoApi.getSearchCombination(queryString)
  }
  const handleSetCombinations = (ids: string[]) => {
    legoApi
      .getCombinationInfo({
        combinationIds: ids,
      })
      .then(res => {
        setValue('combinations', res.data?.waterDrops || [])
      })
  }
  const handleFieldsChange = debounce(data => {
    const field = data[0].name[data[0].name.length - 1]
    const value = data[0].value
    switch (field) {
      case 'ids':
        const ids = value.split(',')
        setValue('ids', ids)
        handleSetCombinations(ids)
        break
      case 'merchants':
      case 'categories':
      case 'maxAmount':
        setValue('condition', form.getFieldValue('condition'))
        getCombinationIds().then(res => {
          const newIds = (res.data || []).map(item => item.id)
          form.setFieldsValue({
            ids: newIds,
          })
          setValue('ids', newIds)
          if (newIds.length) {
            handleSetCombinations(newIds)
          }
        })
        break
    }
  }, 500)

  return (
    <div style={{ margin: '0 20px' }}>
      <Row>
        <Col offset={6}>
          <Typography.Text type="warning">组合id使用 , 分隔(英文字符)</Typography.Text>
        </Col>
      </Row>
      <SchemaForm {...layout} form={form} schema={schema} onFieldsChange={handleFieldsChange} />
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
  editConfig: (id, name, value) => {
    dispatch(setCommonConfig(id, name, value))
  },
})
const mapStateToProps = state => ({
  domain: state.tree.root.config.domain,
})
export default connect(mapStateToProps, mapDispatchToProps)(CombinationList)
